import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const equipmentCategoryTypesAdapter = getAdapter({ idFieldName: 'value' });

const equipmentCategoryTypesSlice = createSlice({
  name: 'equipmentCategoryTypes',
  initialState: equipmentCategoryTypesAdapter.getInitialState(),
  reducers: {
    setEquipmentCategoryTypes: (state, { payload: { equipmentCategoryTypes } }) => {
      equipmentCategoryTypesAdapter.setAll(state, equipmentCategoryTypes);
    },
  },
});

const selectors = equipmentCategoryTypesAdapter.getSelectors(({ equipmentCategoryTypes }) => equipmentCategoryTypes);

export const getEquipmentCategoryTypes = (state) => selectors.selectAll(state);

export const {
  setEquipmentCategoryTypes,
} = equipmentCategoryTypesSlice.actions;

export default equipmentCategoryTypesSlice.reducer;
